const THRESHOLD_ATTRIBUTE_KEY = 'Prezent od';
const THRESHOLD_REQUIRED_PRODUCT_KEY = '_gift_for';
const THRESHOLD_REQUIRED_QUANTITY_KEY = '_gift_quantity';
const GIFT_SET_ATTRIBUTE_FALLBACK_KEY = 'yk_gift_set_id';

class FomoWidget {
  constructor(minutes, productId, widgetId) {
    this.periodMs = minutes * 60 * 1000;
    this.giftProductId = productId;
    this.widgetId = widgetId;

    this._wasModalOpened = this.getLocalStorageDate('was-modal-opened');
    this._wasGiftAdded = this.getLocalStorageDate('was-added');
    this._startedAt = this.getLocalStorageDate('start-date');
    this._isActive = true;

    this.counterModal = document.getElementById('free-products-fomo-counter-modal');
    this.counterWidget = document.getElementById('free-products-fomo-counter');
    this.widget = document.getElementById('free-products-fomo');
    this.addBtn = this.widget.querySelector('.btn.btn--primary-1');
    this.modal = null;

    this.checkIsInitialized();
    setTimeout(this.tryToOpenModal.bind(this), 10_000);
    this.setListeners();
    this.initialModal();
  }

  get wasModalOpened() {
    return this._wasModalOpened;
  }
  set wasModalOpened(wasOpened) {
    this._wasModalOpened = !!wasOpened;
    this.setLocalStorageDate(!!wasOpened, 'was-modal-opened');
  }

  get isActive() {
    return this._isActive;
  }
  set isActive(isActive) {
    if (this.wasGiftAdded) return (this._isActive = false);
    if (!isActive) this.closeModal();
    if (this.widget && !isActive && this.startedAt) this.destroyWidget();
    this._isActive = isActive;
    this.widget.classList[isActive ? 'remove' : 'add']('!hidden');
  }

  get startedAt() {
    return this._startedAt;
  }
  set startedAt(date) {
    this._startedAt = date;
  }

  get wasGiftAdded() {
    return this._wasGiftAdded;
  }
  set wasGiftAdded(wasAdded) {
    this._wasGiftAdded = this._wasGiftAdded ? true : wasAdded;
    if (wasAdded) {
      this.setLocalStorageDate(wasAdded, 'was-added');
      this.destroyWidget();
      this.isActive = false;
    }
  }

  openModal() {
    if (!this.modal || this.wasModalOpened) return;

    this.modal.classList.add('active');
    dataLayerPromise({ event: 'fomo_modal_show' });
    this.initialize();
  }

  closeModal() {
    if (!this.modal) return;
    this.modal.classList.remove('active');
  }
  initialModal() {
    const modal = document.getElementById('modal-fomo-gift');
    const closeElements = modal?.querySelectorAll('.modal-close, img');

    if (!modal) return;
    this.modal = modal;

    closeElements?.forEach((el) =>
      el.addEventListener('click', () => {
        modal.classList.remove('active');
        if (el.tagName.toLowerCase() === 'img') {
          dataLayerPromise({ event: 'fomo_modal_button_click' });
        }
      })
    );
  }

  checkIsGiftAdded() {
    if (!this.giftProductId) return;
    this.wasGiftAdded = Rebuy.SmartCart.cart.items.some(({ product }) => String(product?.id) === this.giftProductId);
  }

  setListeners() {
    if (this.addBtn) {
      this.addBtn.addEventListener('click', () => {
        setTimeout(this.destroyWidget.bind(this), 500);
      });
    }
    setTimeout(this.checkIsGiftAdded.bind(this), 500);
    document.addEventListener('rebuy:cart.change', () => setTimeout(this.checkIsGiftAdded.bind(this), 500));
    document.addEventListener('rebuy:cart.enriched', () => setTimeout(this.checkIsGiftAdded.bind(this), 500));
    document.addEventListener('rebuy:smartcart.show', this.showWidgetEvent.bind(this));
  }

  showWidgetEvent() {
    if (this.isActive) {
      dataLayerPromise({ event: 'fomo_widget_show' });
    } else {
      document.removeEventListener('rebuy:smartcart.show', this.showWidgetEvent.bind(this));
    }
  }

  tryToOpenModal() {
    if (window.innerWidth > 768) return;

    const { remaining } = this.isTimeValid();

    if (this.wasModalOpened) return;
    if (this.isActive && remaining < 30_000) return;
    if (Rebuy?.SmartCart?.cart?.items && Rebuy.SmartCart.cart.items?.length > 0) return;

    this.openModal();
  }

  isTimeValid() {
    const clearMs = (ms) => Math.max(Math.ceil(ms / 1000) * 1000, 0);

    if (this.startedAt && new Date().getTime() - 7 * 86_400_000 > new Date(this.startedAt).getTime()) {
      this.reset();
    }

    return {
      isValid: new Date().getTime() < new Date(this.startedAt).getTime() + this.periodMs,
      remaining: clearMs(new Date(this.startedAt).getTime() + this.periodMs - new Date().getTime()),
    };
  }
  formatTime(ms, returnAsData) {
    const totalSeconds = Math.floor(ms / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    if (returnAsData) {
      return { minutes, seconds };
    }

    return `${minutes} min : ${seconds.toString().padStart(2, '0')} sek`;
  }

  updateModalCounter({ minutes, seconds }) {
    if (!this.counterModal) return;

    const displays = this.counterModal.querySelectorAll('.fomo-counter-display');
    if (!displays.length) return;

    const minStr = String(minutes).padStart(2, '0');
    const secStr = String(seconds).padStart(2, '0');

    const [minTens, minOnes] = minStr;
    const [secTens, secOnes] = secStr;

    displays[0].textContent = minTens;
    displays[1].textContent = minOnes;
    displays[2].textContent = secTens;
    displays[3].textContent = secOnes;
  }
  updateCounters(time) {
    if (time > 0) {
      this.counterWidget.innerText = this.formatTime(time);
      this.updateModalCounter(this.formatTime(time, true));
    } else {
      this.counterWidget.innerText = '00 min : 00 sek';
      this.updateModalCounter({ minutes: 0, seconds: 0 });
    }
  }

  timerInterval() {
    const { isValid, remaining } = this.isTimeValid();
    this.updateCounters(remaining);
    if (this.isActive) {
      this.isActive = isValid;
    } else {
      clearInterval(this.intervalId);
    }
  }

  startCounting() {
    this.timerInterval();
    this.intervalId = setInterval(this.timerInterval.bind(this), 1000);
  }

  checkIsInitialized() {
    this.isActive = this.isTimeValid().isValid;
  }

  initialize() {
    const hasStarted = this.getLocalStorageDate('start-date');
    this.startCounting();

    if (hasStarted) {
      this.startedAt = hasStarted;
    } else {
      this.updateCounters(this.periodMs);
      const now = JSON.parse(JSON.stringify(new Date()));
      this.setLocalStorageDate(now, 'start-date');
      this.startedAt = now;
      this.isActive = true;
      this.wasModalOpened = true;
    }
  }

  setLocalStorageDate(date, key) {
    localStorage.setItem(this.widgetId + '-' + key, JSON.stringify(date));
  }

  getLocalStorageDate(key) {
    const storeDate = localStorage.getItem(this.widgetId + '-' + key);
    if (!storeDate) {
      return null;
    } else {
      return JSON.parse(storeDate);
    }
  }

  destroyWidget() {
    this.widget.remove();
  }

  reset() {
    localStorage.removeItem(`${this.widgetId}-start-date`);
    localStorage.removeItem(`${this.widgetId}-was-added`);
    localStorage.removeItem(`${this.widgetId}-was-modal-opened`);
  }
}

const setUpWidgetCarousel = (element) => {
  const id = element.getAttribute('id');
  if (!id) return;

  if (element.classList.contains('swiper-initialized')) {
    element.swiper?.update?.();
    return;
  }

  new Swiper(`#${id}`, {
    direction: 'horizontal',
    slidesPerView: 'auto',
    spaceBetween: 12,
    activeIndex: 1,
    loop: false,
    navigation: {
      nextEl: `#next-${id}`,
      prevEl: `#prev-${id}`,
    },
  });
};

const setUpWidgetCarousels = () => {
  document.querySelectorAll('.cart-threshold-carousel').forEach(setUpWidgetCarousel);
};

const updateActiveWidgetCarousels = () => {
  document.querySelectorAll('.cart-gift-set:not(.hidden) .cart-threshold-carousel').forEach(setUpWidgetCarousel);
};

const setUpWidgetAccordion = () => {
  const header = document.getElementById('free-products-header');
  const arrow = document.getElementById('free-products-arrow');
  const body = document.getElementById('free-products-body');

  if (!arrow)
    header?.addEventListener('click', () => {
      if (body) body?.classList?.toggle('hidden');
      if (header) header?.querySelector('button')?.classList?.toggle('hidden');
      if (arrow) arrow?.classList?.toggle('rotate-180');

      const gtmAnalytics = () => {
        const widget = document.getElementById('free-products');
        const gifts = document.querySelectorAll('.cart-gift-set:not(.hidden) .cart-free-product');

        dataLayerPromise({
          event: 'cart_gratis_get',
        });

        if (widget && gifts) {
          gifts.forEach((gift) => {
            dataLayerPromise({
              event: 'cart_gratis_view',
              product_name: gift.getAttribute('data-product-name') ?? '',
              product_id: +gift.getAttribute('data-product-id') ?? null,
            });
          });
        }
      };
      if (body && !body.classList.contains('hidden')) {
        gtmAnalytics();
      }
    });
};

const handleAddGiftsAnalytics = () => {
  const giftProducts = document.querySelectorAll('.cart-free-product');
  giftProducts.forEach((product) => {
    product.querySelector('.btn')?.addEventListener('click', () => {
      dataLayerPromise({
        event: 'cart_gratis_add',
        product_name: product.getAttribute('data-product-name'),
        product_id: +product.getAttribute('data-product-id'),
        status: 'success',
      });
    });
  });
};

const handleWidgetViewAnalytics = () => {
  const cartJson = document.getElementById('SmartCartJson').textContent;
  const cartData = JSON.parse(cartJson);
  const { is_gift_widget_active, is_fomo_gift_widget_active } = cartData;
  if ((is_gift_widget_active && getActiveGiftSetId()) || (is_fomo_gift_widget_active && window?.fomoWidget?.isActive)) {
    dataLayerPromise({
      event: 'cart_gratis_view_get',
    });
  }
};

const collapseWidgetAccordion = () => {
  const header = document.getElementById('free-products-header');
  const arrow = document.getElementById('free-products-arrow');
  const body = document.getElementById('free-products-body');

  const cartData = JSON.parse(document.getElementById('SmartCartJson').textContent);
  if (!cartData.is_gift_widget_active || !getActiveGiftSetId()) return;

  if (body) body?.classList?.add('hidden');
  if (header) header?.querySelector('button')?.classList?.remove('hidden');
  if (arrow) arrow?.classList?.add('rotate-180');
};

// const updateGiftProductPrice = () => {
//   const cartItems = Rebuy.SmartCart?.cart?.items || [];
//   const cartVariants = cartItems.flatMap((item) => item?.product?.variants);
//   const giftsInCart = document.querySelectorAll('.tag-gratis_product');
//
//   giftsInCart.forEach((giftsInCart) => {
//     const info = giftsInCart.querySelector('.rebuy-cart__flyout-item-info-first');
//     const variantId = +giftsInCart.getAttribute('data-variant');
//     const price = cartVariants.find((v) => v?.id === variantId)?.compare_at_price;
//
//     if (price && info) {
//       const formattedPrice = String(price).replace('.', ',') + ' zł';
//       info.setAttribute('data-price-content', formattedPrice);
//     }
//   });
// };

const getCartItemProductId = (item) => Number(item?.product?.id || item?.product_id);

const getCartItemVariantId = (item) => Number(item?.variant_id || item?.id || item?.variant?.id);

const updateGiftProductSelectIfVariantIsAdded = (select, giftItems) => {
  if (!select || giftItems.length !== 1) return;

  const variantId = getCartItemVariantId(giftItems[0]);
  if (Number(select.value) !== variantId) {
    select.value = String(variantId);
    select.querySelectorAll('option').forEach((option) => {
      option.removeAttribute('selected');
      if (Number(option.value) === variantId) {
        option.setAttribute('selected', '');
      }
    });
  }
};

const normalizeGiftThreshold = (threshold) => {
  if (threshold === null || threshold === undefined) return '';

  const normalized = String(threshold)
    .replace(/\s*zł\s*$/i, '')
    .replace(/\s/g, '')
    .replace(',', '.');
  const thresholdNumber = Number(normalized);

  return Number.isFinite(thresholdNumber) ? String(thresholdNumber) : String(threshold);
};

const getLineItemProperty = (item, key) => {
  const properties = item?.properties;
  if (!properties) return undefined;

  if (Array.isArray(properties)) {
    return properties.find((property) => property?.name === key || property?.key === key)?.value;
  }

  return properties[key];
};

const getGiftThreshold = (item) => normalizeGiftThreshold(getLineItemProperty(item, THRESHOLD_ATTRIBUTE_KEY));

const getGiftItemsForThreshold = (cartItems, threshold) => {
  const normalizedThreshold = normalizeGiftThreshold(threshold);
  if (!normalizedThreshold) return [];

  return cartItems.filter((item) => getGiftThreshold(item) === normalizedThreshold);
};

const refreshRebuyCartAfterGiftRemoval = () => {
  if (typeof window.Rebuy?.Cart?.fetchCart !== 'function') return;

  setTimeout(() => {
    Rebuy.Cart.fetchCart();
  }, 150);
};

const setProductButtonClickListener = (product, variantId, shouldGiftBeInCart, products, threshold) => {
  const button = product.querySelector('button.btn');
  const buttons = [];

  const properties = { [THRESHOLD_ATTRIBUTE_KEY]: normalizeGiftThreshold(threshold) + ' zł' };

  products.forEach((product) => buttons.push(product.querySelector('button.btn')));

  button.onclick = () => {
    let id = variantId;
    if (product.querySelector('select')) {
      id = product.querySelector('select').value * 1;
    }
    if (shouldGiftBeInCart) {
      buttons.forEach((button) => (button.disabled = true));
      Rebuy.Cart.addItem({ quantity: 1, id, properties });
    }
  };
};

const buttonStateHandler = (element, isActive, text) => {
  element.querySelectorAll('button.btn, select').forEach((el) => {
    if (isActive) {
      el.removeAttribute('disabled');
      el.classList.remove('opacity-50');
    } else {
      el.setAttribute('disabled', 'disabled');
      el.classList.add('opacity-50');
    }
    if (el.tagName.toLowerCase() === 'button') el.innerHTML = text ?? 'DODAJ';

    if (el.tagName.toLowerCase() === 'button' && text === 'DODANO INNY') {
      el.classList.add('isOtherAdded');
    } else if (el.classList.contains('isOtherAdded')) {
      el.classList.remove('isOtherAdded');
    }
  });
};

const addedBtnMsg = `
<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="gift-icon">
  <g clip-path="url(#clip0_1184_102945)">
    <path d="M5.24937 7.0013L6.41605 8.16797L8.74939 5.83464M12.8327 7.0013C12.8327 10.223 10.2211 12.8346 6.99938 12.8346C3.7777 12.8346 1.16602 10.223 1.16602 7.0013C1.16602 3.77964 3.7777 1.16797 6.99938 1.16797C10.2211 1.16797 12.8327 3.77964 12.8327 7.0013Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
  </g>
  <defs>
    <clipPath id="clip0_1184_102945">
      <rect width="14.0001" height="14" fill="white"/>
    </clipPath>
  </defs>
</svg>
<span class="windows-padding-l">DODANO</span>
`;

const productActiveStateHandler = (element, isActive, isAdded, isOtherAdded) => {
  if (isAdded) {
    element.classList.remove('gift-opacity-60');
    setTimeout(() => buttonStateHandler(element, false, addedBtnMsg), 20);
    return;
  }

  if (isOtherAdded) {
    element.classList.remove('gift-opacity-60');
    setTimeout(() => buttonStateHandler(element, false, 'DODANO INNY'), 10);
    return;
  }

  if (isActive) {
    element.classList.remove('gift-opacity-60');
    buttonStateHandler(element, isActive);
  } else {
    element.classList.add('gift-opacity-60');
    buttonStateHandler(element, isActive);
  }
};

const giftInCartHandler = (shouldGiftBeInCart, gift, giftsFromThreshold) => {
  if (!gift && giftsFromThreshold.length === 0) return;

  if (!shouldGiftBeInCart) {
    giftsFromThreshold.forEach(Rebuy.SmartCart.removeItem);
    refreshRebuyCartAfterGiftRemoval();
    return;
  }

  if (!gift) return;

  let removedOtherGift = false;
  giftsFromThreshold.forEach((item) => {
    if (item.key !== gift.key) {
      Rebuy.SmartCart.removeItem(item);
      removedOtherGift = true;
    }
  });
  if (removedOtherGift) refreshRebuyCartAfterGiftRemoval();

  if (gift?.quantity >= 2) {
    Rebuy.Cart.decreaseItem(gift);
  }
};

const getItemsTotalValue = (items = []) => {
  return items.reduce((total, item) => {
    const price = item?.original_price || 0;
    const quantity = item?.quantity || 0;

    return total + price * quantity;
  }, 0);
};

const handleDigitalProductsInCart = () => {
  const cartItems = Rebuy.SmartCart?.cart?.items || [];

  const digitalProducts = cartItems.filter((item) => item?.product?.tags?.includes('digital'));

  const digitalInformation = document.querySelector('.widget-digital-product-text');

  const hasDigitalProducts = digitalProducts.length > 0;

  digitalInformation?.classList.toggle('hidden', !hasDigitalProducts);

  return {
    digitalProductsTotalValue: getItemsTotalValue(digitalProducts),
  };
};

const parseSmartCartData = () => {
  const el = document.getElementById('SmartCartJson');
  if (!el) return {};

  try {
    return JSON.parse(el.innerText || el.textContent || '{}');
  } catch (error) {
    console.error('Nie udało się sparsować #SmartCartJson:', error);
    return {};
  }
};

const normalizeGiftSetValue = (value) => (value === null || value === undefined ? '' : String(value));

const getGiftSetArray = (value) => (Array.isArray(value) ? value : []);

const getGiftSetAttributeKey = () => parseSmartCartData().gift_set_attribute_key || GIFT_SET_ATTRIBUTE_FALLBACK_KEY;

const getActiveGiftSetId = () => {
  const widget = document.getElementById('free-products');
  const attributeKey = getGiftSetAttributeKey();
  const cartAttributeValue = window.Rebuy?.SmartCart?.cart?.attributes?.[attributeKey];

  if (widget?.dataset && Object.prototype.hasOwnProperty.call(widget.dataset, 'selectedGiftSetId')) {
    return normalizeGiftSetValue(widget.dataset.selectedGiftSetId);
  }

  return normalizeGiftSetValue(cartAttributeValue || parseSmartCartData().selected_gift_set_id);
};

class GiftSetSessionManager {
  constructor(config) {
    this.config = config || {};
    this.attributeKey = this.config.gift_set_attribute_key || GIFT_SET_ATTRIBUTE_FALLBACK_KEY;
    this.currentSetId = normalizeGiftSetValue(this.config.selected_gift_set_id);
    this.debounceMs = 100;
    this._timer = null;
    this._busy = false;
    this._pending = false;
    this._suppressNextSync = false;

    this.applySelectedSet(this.currentSetId);
  }

  scheduleSync(delay = this.debounceMs) {
    if (this._suppressNextSync) {
      this._suppressNextSync = false;
      return;
    }

    if (this._timer) clearTimeout(this._timer);
    this._timer = setTimeout(() => this.sync().catch(console.error), delay);
  }

  _getCartRuleSource() {
    const source = {
      variant_ids: [],
      collection_ids: [],
    };

    getGiftSetArray(window.Rebuy?.SmartCart?.cart?.items).forEach((item) => {
      if (getGiftSetArray(item.product?.tags).includes('gratis_product')) return;

      const variantId = normalizeGiftSetValue(item.variant_id || item.id || item.variant?.id);
      if (variantId) {
        source.variant_ids.push(variantId);
      }

      getGiftSetArray(item.product?.collections || item.collections).forEach((collection) => {
        const collectionId = normalizeGiftSetValue(collection?.id || collection);
        if (collectionId) {
          source.collection_ids.push(collectionId);
        }
      });

      getGiftSetArray(item.product?.collection_ids || item.collection_ids).forEach((collectionId) => {
        const normalizedCollectionId = normalizeGiftSetValue(collectionId);
        if (normalizedCollectionId) {
          source.collection_ids.push(normalizedCollectionId);
        }
      });
    });

    return source;
  }

  _getRuleRequiredValues(rule) {
    return [
      ...getGiftSetArray(rule.variant_ids).map((id) => `variant:${normalizeGiftSetValue(id)}`),
      ...getGiftSetArray(rule.collection_ids).map((id) => `collection:${normalizeGiftSetValue(id)}`),
    ].filter((id) => !id.endsWith(':'));
  }

  _rulePasses(rule) {
    const source = this._getCartRuleSource();
    const requiredValues = this._getRuleRequiredValues(rule).map(normalizeGiftSetValue).filter(Boolean);
    const sourceSet = new Set([
      ...getGiftSetArray(source.variant_ids).map((id) => `variant:${normalizeGiftSetValue(id)}`),
      ...getGiftSetArray(source.collection_ids).map((id) => `collection:${normalizeGiftSetValue(id)}`),
    ]);
    const containsAll = requiredValues.every((id) => sourceSet.has(id));
    const containsAtLeastOne = requiredValues.some((id) => sourceSet.has(id));

    switch (
      String(rule?.operator || '')
        .toLowerCase()
        .trim()
    ) {
      case 'contains all':
        return containsAll;
      case 'contains at least one':
        return containsAtLeastOne;
      case 'not contains all':
      case 'not contains at least one':
        return !containsAtLeastOne;
      default:
        return false;
    }
  }

  _setPasses(giftSet) {
    return getGiftSetArray(giftSet?.rules).every((rule) => this._rulePasses(rule));
  }

  _resolveMatchingSet() {
    return getGiftSetArray(this.config.gift_sets).find((giftSet) => this._setPasses(giftSet)) || null;
  }

  _readCartAttribute() {
    return normalizeGiftSetValue(window.Rebuy?.SmartCart?.cart?.attributes?.[this.attributeKey]);
  }

  _getConfiguredGiftVariantIds() {
    return new Set(
      getGiftSetArray(this.config.gift_sets)
        .flatMap((giftSet) => getGiftSetArray(giftSet.conditions))
        .flatMap((condition) => getGiftSetArray(condition.gifts))
        .flatMap((gift) => getGiftSetArray(gift.variant_ids))
        .map(Number)
        .filter(Boolean)
    );
  }

  _getGiftRemovalUpdates() {
    const configuredGiftVariantIds = this._getConfiguredGiftVariantIds();
    const updates = {};

    getGiftSetArray(window.Rebuy?.SmartCart?.cart?.items).forEach((item) => {
      const variantId = Number(item.variant_id || item.id);
      if (configuredGiftVariantIds.has(variantId)) {
        updates[item.key || variantId] = 0;
      }
    });

    return updates;
  }

  async _persistSelectedSet(setId, options = {}) {
    const updates = options.removeGifts ? this._getGiftRemovalUpdates() : {};
    const body = {
      attributes: { [this.attributeKey]: setId || '' },
    };

    if (Object.keys(updates).length > 0) {
      body.updates = updates;
    }

    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });

    if (!response.ok) throw new Error(`Nie udało się zapisać ${this.attributeKey}`);

    const cart = await response.json();
    window.Rebuy?.SmartCart?.setCart?.(cart);
    if (Object.keys(updates).length > 0) {
      refreshRebuyCartAfterGiftRemoval();
    }

    return {
      cart,
      removedGiftsCount: Object.keys(updates).length,
      selectedSetId: normalizeGiftSetValue(setId),
    };
  }

  applySelectedSet(setId, options = {}) {
    const normalizedSetId = normalizeGiftSetValue(setId);
    const widget = document.getElementById('free-products');
    const updateProducts = options.updateProducts !== false;

    if (widget) {
      widget.dataset.selectedGiftSetId = normalizedSetId;
      widget.classList[normalizedSetId ? 'remove' : 'add']('!hidden');
    }

    document.querySelectorAll('.cart-gift-set').forEach((element) => {
      const isActive = normalizeGiftSetValue(element.getAttribute('data-gift-set-id')) === normalizedSetId;
      element.classList[isActive ? 'remove' : 'add']('!hidden');
    });

    updateActiveWidgetCarousels();

    if (updateProducts && typeof updateEveryProductHandler === 'function') {
      setTimeout(updateEveryProductHandler, 0);
    }
  }

  async sync() {
    if (this._busy) {
      this._pending = true;
      return;
    }

    this._busy = true;

    try {
      const selectedSet = this._resolveMatchingSet();
      const nextSetId = normalizeGiftSetValue(selectedSet?.id);
      const cartSetId = this._readCartAttribute();
      const shouldPersist = nextSetId !== cartSetId;

      this.currentSetId = nextSetId;
      this.applySelectedSet(nextSetId);

      if (shouldPersist) {
        await this._persistSelectedSet(nextSetId);
      }
    } finally {
      this._busy = false;

      if (this._pending) {
        this._pending = false;
        this.scheduleSync();
      }
    }
  }

  async reset(options = {}) {
    const removeGifts = options.removeGifts !== false;

    if (this._timer) clearTimeout(this._timer);
    this._pending = false;
    this._suppressNextSync = true;
    this.currentSetId = '';
    this.applySelectedSet('', { updateProducts: false });

    return this._persistSelectedSet('', { removeGifts });
  }
}

const getGiftSetManager = () => {
  const config = parseSmartCartData();
  if (!getGiftSetArray(config.gift_sets).length) return null;

  if (!window.ykGiftSetSessionManager) {
    window.ykGiftSetSessionManager = new GiftSetSessionManager(config);
  }

  return window.ykGiftSetSessionManager;
};

const syncGiftSetSelection = (delay) => {
  const manager = getGiftSetManager();
  if (!manager) return;

  manager.scheduleSync(delay);
};

window.giftSets = {
  ...(window.giftSets || {}),
  getActiveSetId: getActiveGiftSetId,
  getConfig: () => getGiftSetManager()?.config || parseSmartCartData(),
  reset: (options) => getGiftSetManager()?.reset(options),
  sync: async () => {
    const manager = getGiftSetManager();
    if (!manager) return null;

    await manager.sync();
    return manager.currentSetId;
  },
};

const handleUseDiscountedTotal = (threshold) => {
  const cartJson = document.getElementById('SmartCartJson').textContent;
  const cartData = JSON.parse(cartJson);
  const { use_discounted_total: total, use_discounted_total_for_fomo: fomo } = cartData;

  const { digitalProductsTotalValue } = handleDigitalProductsInCart();
  let shouldGiftBeInCart = (Rebuy.SmartCart.cart.original_total_price - digitalProductsTotalValue) / 100 >= threshold;

  if ((total || fomo) && Rebuy.SmartCart.cart.total_discount > 0) {
    shouldGiftBeInCart = (Rebuy.SmartCart.cart.total_price - digitalProductsTotalValue) / 100 >= threshold;
  }

  return { shouldGiftBeInCart, use_discounted_total: total || fomo };
};

const updateEveryProductHandler = () => {
  const products = document.querySelectorAll('.cart-free-product');
  const activeGiftSetId = getActiveGiftSetId();

  products.forEach((product) => {
    const cartItems = Rebuy.SmartCart.cart.items || [];
    const select = product.querySelector('select');
    const threshold = normalizeGiftThreshold(product.getAttribute('data-threshold'));
    const hasThreshold = !!threshold && Number.isFinite(Number(threshold));
    const productGiftSetId = normalizeGiftSetValue(product.getAttribute('data-gift-set-id'));
    const isGiftSetProduct = !!productGiftSetId;
    const isActiveGiftSetProduct = isGiftSetProduct ? activeGiftSetId && productGiftSetId === activeGiftSetId : true;
    const variantId = Number(product.getAttribute('data-variant-id'));
    const productId = Number(product.getAttribute('data-product-id'));
    const giftsFromThreshold = getGiftItemsForThreshold(cartItems, threshold);
    const productGiftsFromThreshold = giftsFromThreshold.filter((item) => getCartItemProductId(item) === productId);
    const gift =
      giftsFromThreshold.find((item) => getCartItemVariantId(item) === variantId) || productGiftsFromThreshold[0];
    const isGiftInCart = productGiftsFromThreshold.length > 0;
    const isOtherGiftInThreshold = giftsFromThreshold.length > 0 && !isGiftInCart;

    const { shouldGiftBeInCart } =
      isActiveGiftSetProduct && hasThreshold ? handleUseDiscountedTotal(threshold) : { shouldGiftBeInCart: false };
    const allGiftsFromThreshold = [...document.querySelectorAll('.cart-free-product')].filter((item) => {
      return (
        normalizeGiftSetValue(item.getAttribute('data-gift-set-id')) === productGiftSetId &&
        normalizeGiftThreshold(item.getAttribute('data-threshold')) === threshold
      );
    });
    const canAddGift = hasThreshold && shouldGiftBeInCart && giftsFromThreshold.length === 0;

    updateGiftProductSelectIfVariantIsAdded(select, productGiftsFromThreshold);
    productActiveStateHandler(product, canAddGift, isGiftInCart, isOtherGiftInThreshold);
    if (isActiveGiftSetProduct && hasThreshold) giftInCartHandler(shouldGiftBeInCart, gift, giftsFromThreshold);
    setProductButtonClickListener(product, variantId, canAddGift, allGiftsFromThreshold, threshold);
  });
};

const handleCalculateThresholdMissingAmount = () => {
  document.querySelectorAll('.cart-threshold').forEach((element) => {
    const threshold = +element.getAttribute('data-threshold');

    const { use_discounted_total } = handleUseDiscountedTotal(threshold);
    const { digitalProductsTotalValue } = handleDigitalProductsInCart();
    let missing = '';
    if (use_discounted_total) {
      missing = threshold - (Rebuy.SmartCart.cart.total_price - digitalProductsTotalValue) / 100;
    } else {
      missing = threshold - (Rebuy.SmartCart.cart.original_total_price - digitalProductsTotalValue) / 100;
    }

    const display = element.querySelector('.cart-threshold-display');
    if (!display) return;

    if (missing > 0) {
      display.innerHTML = `. Brakuje Ci tylko <strong>${missing.toFixed(2).replace('.', ',')} zł!</strong>`;
    } else {
      display.innerHTML = '';
    }
  });
};

const getAllActiveGifts = () => {
  const cartJson = document.getElementById('SmartCartJson').textContent;
  const cartData = JSON.parse(cartJson);

  const widgetsKeys = ['multi_threshold_gifts'];

  const { active_gifts, active_gifts_thresholds } = cartData;

  const additionalGifts = widgetsKeys.flatMap((key) => {
    return cartData[key].details.active_gifts;
  });

  const additionalThresholds = widgetsKeys.flatMap((key) => {
    return cartData[key].details.active_gifts_thresholds;
  });

  return [
    [...active_gifts, ...additionalGifts],
    [...active_gifts_thresholds, ...additionalThresholds],
  ];
};

const handleDeleteProductAfterPromoExpiry = () => {
  const cartJson = document.getElementById('SmartCartJson').textContent;
  const cartData = JSON.parse(cartJson);
  const cartItems = Rebuy.SmartCart?.cart?.items || [];
  const { all_gifts_products } = cartData;
  const [active_gifts] = getAllActiveGifts();

  if (!cartData || !all_gifts_products) return;
  if (Array.isArray(all_gifts_products)) {
    const productsIdsToDelete = all_gifts_products.filter((id) => !active_gifts.includes(id));
    const cartItemsToDelete = cartItems.filter((item) => productsIdsToDelete.includes(item.product?.id.toString()));
    cartItemsToDelete.forEach(Rebuy.SmartCart.removeItem);
    if (cartItemsToDelete.length > 0) refreshRebuyCartAfterGiftRemoval();
  }
};

const handleRemoveGiftFromCartAfterAmountIsBelowTheThreshold = () => {
  const [active_gifts, active_gifts_thresholds] = getAllActiveGifts();

  const cartItems = Rebuy.SmartCart?.cart?.items || [];
  cartItems.forEach((cartItem) => {
    if (!active_gifts) return;
    const productId = String(cartItem.product?.id);
    if (!active_gifts.includes(productId)) return;

    const thresholdFromProperty = getGiftThreshold(cartItem);
    const isGiftItem = thresholdFromProperty || getGiftSetArray(cartItem.product?.tags).includes('gratis_product');
    if (!isGiftItem) return;

    const threshold = thresholdFromProperty || active_gifts_thresholds[active_gifts.indexOf(productId)];
    if (!threshold) return;

    const { shouldGiftBeInCart } = handleUseDiscountedTotal(threshold);

    if (!shouldGiftBeInCart) {
      Rebuy.SmartCart.removeItem(cartItem);
      refreshRebuyCartAfterGiftRemoval();
    }
  });
};

const addAutomaticGiftToCartHandler = () => {
  const gift_product = document.getElementById('SmartCartJson');
  const giftProductData = gift_product.textContent;
  const giftProductJson = JSON.parse(giftProductData);

  let giftID = '';
  let gratis_threshold = giftProductJson.gratis_product_threshold;
  let gratis_product_redirect_url = giftProductJson.cart_gratis_product_redirect_url;

  if (giftProductJson && giftProductJson.gratis_product && gratis_threshold) {
    let threshold = JSON.parse(giftProductJson.gratis_product_threshold);

    const product = giftProductJson.gratis_product;
    giftID = product.variants[0].id;

    let cartItems = Rebuy.SmartCart.cart.items || [];
    const gift = cartItems.find((item) => item.variant_id === giftID);

    const { digitalProductsTotalValue } = handleDigitalProductsInCart();
    let shouldGiftBeInCart = (Rebuy.SmartCart.cart.original_total_price - digitalProductsTotalValue) / 100 >= threshold;

    if (!shouldGiftBeInCart) {
      if (gift) {
        Rebuy.SmartCart.removeItem(gift);
        refreshRebuyCartAfterGiftRemoval();
      }
      return;
    }

    const giftExisted = cartItems.some((i) => i.variant_id === giftID);

    if (gift && (gift.quantity >= 2 || !shouldGiftBeInCart)) {
      Rebuy.Cart.decreaseItem(gift);
    }

    const anyGiftExisted = cartItems.some((item) => {
      return item?.product?.tags?.includes('gratis_product');
    });

    const physicalProducts = cartItems.filter((item) => {
      return !item?.product?.tags?.includes('tag-ebook');
    });

    if (physicalProducts.length === 0) {
      if (gift) {
        Rebuy.SmartCart.removeItem(gift);
        refreshRebuyCartAfterGiftRemoval();
      }
      return;
    }

    const properties = { [THRESHOLD_ATTRIBUTE_KEY]: normalizeGiftThreshold(threshold) + ' zł' };

    const redirectProps = {
      _redirectTo: gratis_product_redirect_url,
    };

    if (!giftExisted && !anyGiftExisted && shouldGiftBeInCart) {
      Rebuy.Cart.addItem({
        id: giftID,
        quantity: 1,
        properties: {
          ...(!!gratis_product_redirect_url && redirectProps),
          ...properties,
        },
      });
    }
  }
};

const calculateGiftBlockedMissingAmount = (threshold) => {
  const numericThreshold = Number(threshold);

  if (!numericThreshold || Number.isNaN(numericThreshold)) {
    return null;
  }

  if (typeof Rebuy === 'undefined' || !Rebuy.SmartCart || !Rebuy.SmartCart.cart) {
    return null;
  }

  const { use_discounted_total } = handleUseDiscountedTotal(numericThreshold);
  const { digitalProductsTotalValue } = handleDigitalProductsInCart();

  const cart = Rebuy.SmartCart.cart;

  const cartTotal = use_discounted_total ? cart.total_price : cart.original_total_price;

  const missing = numericThreshold - (cartTotal - digitalProductsTotalValue) / 100;

  return Math.max(missing, 0);
};

const formatGiftBlockedPricePLN = (amount) => {
  return `${amount.toFixed(2).replace('.', ',')} zł`;
};

const createAndShowModal = () => {
  const buttons = document.querySelectorAll('.gift-blocked-btn-info');
  const modal = document.getElementById('gift-blocked-modal');

  if (!buttons.length || !modal) return;

  const dialog = modal.querySelector('[data-gift-blocked-dialog]');
  const closeButtons = modal.querySelectorAll('[data-gift-blocked-close]');
  const amountElement = modal.querySelector('[data-gift-blocked-missing-amount]');

  if (!dialog || !amountElement) return;

  const openModal = (threshold) => {
    const missingAmount = calculateGiftBlockedMissingAmount(threshold);

    if (missingAmount === null) return;

    amountElement.textContent = formatGiftBlockedPricePLN(missingAmount);

    modal.classList.remove('pointer-events-none', 'opacity-0');
    modal.classList.add('pointer-events-auto', 'opacity-100');
    modal.setAttribute('aria-hidden', 'false');

    dialog.classList.remove('translate-y-4', 'scale-[0.98]');
    dialog.classList.add('translate-y-0', 'scale-100');

    document.body.classList.add('overflow-hidden');
  };

  const closeModal = () => {
    modal.classList.remove('pointer-events-auto', 'opacity-100');
    modal.classList.add('pointer-events-none', 'opacity-0');
    modal.setAttribute('aria-hidden', 'true');

    dialog.classList.remove('translate-y-0', 'scale-100');
    dialog.classList.add('translate-y-4', 'scale-[0.98]');

    document.body.classList.remove('overflow-hidden');
  };

  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      openModal(button.getAttribute('data-threshold'));
    });
  });

  closeButtons.forEach((button) => {
    button.addEventListener('click', closeModal);
  });

  modal.addEventListener('click', (event) => {
    if (!dialog.contains(event.target)) {
      closeModal();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') {
      closeModal();
    }
  });
};

document.addEventListener('DOMContentLoaded', createAndShowModal);

const initializeFomoWidget = () => {
  const getFomoWidget = document.getElementById('free-products-fomo');
  if (getFomoWidget) {
    const minutes = getFomoWidget.getAttribute('data-minutes');
    const widgetId = getFomoWidget.getAttribute('data-widget-id');
    const productId = getFomoWidget.getAttribute('data-gift-product-id');
    window.yk_fomo = new FomoWidget(minutes, productId, widgetId);
  }
};

document.addEventListener('rebuy:smartcart.ready', () => {
  setUpWidgetCarousels();
  handleAddGiftsAnalytics();
  // setUpWidgetAccordion();
  setTimeout(initializeFomoWidget, 100);
  setTimeout(() => syncGiftSetSelection(0), 50);
  setTimeout(updateEveryProductHandler, 350);
  setTimeout(handleDeleteProductAfterPromoExpiry, 100);
  setTimeout(handleCalculateThresholdMissingAmount, 100);
  setTimeout(handleRemoveGiftFromCartAfterAmountIsBelowTheThreshold, 100);
  setTimeout(createAndShowModal, 300);
});

document.addEventListener('rebuy:cart.change', () => {
  setTimeout(() => syncGiftSetSelection(0), 100);
  setTimeout(updateEveryProductHandler, 250);
  setTimeout(handleDeleteProductAfterPromoExpiry, 300);
  setTimeout(handleCalculateThresholdMissingAmount, 300);
  setTimeout(handleRemoveGiftFromCartAfterAmountIsBelowTheThreshold, 300);
  setTimeout(setUpWidgetCarousels, 300);
});

document?.addEventListener('rebuy:smartcart.show', () => {
  syncGiftSetSelection(0);
  handleWidgetViewAnalytics();
  // collapseWidgetAccordion();
  if (window.yk_fomo) window.yk_fomo.initialize();
});
